"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BuilderUseShoppingCart = BuilderUseShoppingCart;
var _react = _interopRequireWildcard(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _utils = require("../utils");
var _config = require("react-platform-shoppingcart/dist/config");
var _config2 = require("../config");
var _ShoppingCartActions = require("../ShoppingCart/ShoppingCartActions");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function BuilderUseShoppingCart() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$shoppingCartType = _ref.shoppingCartTypes,
    shoppingCartTypes = _ref$shoppingCartType === void 0 ? _config2.shoppingCartTypes : _ref$shoppingCartType;
  return function useShoppingCart() {
    var dispatch = (0, _reactRedux.useDispatch)();
    var params = (0, _reactRouterDom.useParams)();
    var shoppingCartType = (0, _react.useMemo)(function () {
      return params !== null && params !== void 0 && params.path ? _lodash.default.find(shoppingCartTypes, {
        path: params.path
      }) : shoppingCartTypes[0];
    }, [params === null || params === void 0 ? void 0 : params.path]);
    var _useSelector = (0, _reactRedux.useSelector)(function (_ref2) {
        var shoppingCartReducer = _ref2.shoppingCartReducer,
          auth = _ref2.auth;
        return {
          fetchCartInProgress: shoppingCartReducer.fetchCartInProgress,
          fetchCartItemsInProgress: shoppingCartReducer.fetchCartItemsInProgress,
          cart: shoppingCartReducer.cart,
          cartItems: shoppingCartReducer.cartItems,
          user: auth.user
        };
      }),
      fetchCartInProgress = _useSelector.fetchCartInProgress,
      fetchCartItemsInProgress = _useSelector.fetchCartItemsInProgress,
      cart = _useSelector.cart,
      cartItems = _useSelector.cartItems,
      user = _useSelector.user;
    var cartId = (0, _react.useMemo)(function () {
      var _$find;
      return (_$find = _lodash.default.find(user.carts, {
        name: shoppingCartType === null || shoppingCartType === void 0 ? void 0 : shoppingCartType.cartName
      })) === null || _$find === void 0 ? void 0 : _$find.id;
    });
    (0, _react.useEffect)(function () {
      if (cartId) {
        // Fetch the cart
        fetchShoppingCart(cartId);
        // fetch the cart items
        fetchShoppingCartItems(cartId);
      }
    }, []);
    var fetchShoppingCart = function fetchShoppingCart(cartId) {
      dispatch({
        type: _ShoppingCartActions.FETCH_SHOPPING_CART,
        id: cartId,
        params: {
          _fields: ['name', 'total_amount', 'total_price_with_coupon', 'shipping_amount']
        }
      });
    };
    var fetchShoppingCartItems = function fetchShoppingCartItems(cartId) {
      dispatch({
        type: _ShoppingCartActions.FETCH_SHOPPING_CART_ITEMS,
        params: {
          'cart.id': cartId,
          _fields: ['id', 'quantity', 'salable_item', 'seller', 'is_primary_product', 'can_update_quantity', 'options_linked_to_cart_item', 'total_price'],
          _embed: ['salable_item']
        }
      });
    };
    (0, _react.useEffect)(function () {
      // we fetch use for get the user balance
      dispatch({
        type: 'FETCH_USER',
        params: {
          _embed: 'wallets'
        }
      });
    }, []);

    // Get the primary product from the cart items because we only display them
    var primaryCartItems = (0, _react.useMemo)(function () {
      return _lodash.default.filter(cartItems, {
        is_primary_product: true
      });
    }, [cartItems]);
    var subTotal = (0, _react.useMemo)(function () {
      return primaryCartItems === null || primaryCartItems === void 0 ? void 0 : primaryCartItems.map(function (item) {
        return item.total_price;
      }).reduce(function (a, b) {
        return a + b;
      }, 0);
    }, [primaryCartItems]);
    var subTotalOriginal = (0, _react.useMemo)(function () {
      return primaryCartItems === null || primaryCartItems === void 0 ? void 0 : primaryCartItems.map(function (item) {
        return (item.salable_item.original_price || 0) * item.salable_item.quantity;
      }).reduce(function (a, b) {
        return a + b;
      }, 0);
    }, [primaryCartItems]);

    // Groupe the cartItem by their seller (the creater of the product) it's return [{ seller: {id: 1, name: 'john smith}, items: [{..}, {...}, ...] }]
    var primaryCartItemsGroupedBySeller = (0, _react.useMemo)(function () {
      return _lodash.default.chain(primaryCartItems).groupBy(function (item) {
        var _item$salable_item$us;
        return ((_item$salable_item$us = item.salable_item.user) === null || _item$salable_item$us === void 0 ? void 0 : _item$salable_item$us.id) || 'admin';
      }).map(function (value, key) {
        return {
          seller: value[0].seller,
          items: value
        };
      }).value();
    }, [primaryCartItems]);
    var itemsNumber = (0, _react.useMemo)(function () {
      return !_lodash.default.isEmpty(primaryCartItems) ? _lodash.default.sumBy(primaryCartItems, 'quantity') : 0;
    }, [primaryCartItems]);
    var buyerCommission = (0, _react.useMemo)(function () {
      return (0, _utils.getCommissionBeforePurchaseAmount)(cartItems);
    }, [cartItems]);
    var calculateAmountToBePayed = function calculateAmountToBePayed() {
      var total_amount = _config.COUPON_ENABLED ? cart === null || cart === void 0 ? void 0 : cart.total_price_with_coupon : cart.total_amount;
      if (!_config.KITTY_ENABLED) return total_amount;
      // todo: handle kitty
      // return (total_amount - kittyAmount / KITTY_EXCHANGE_RATE).toFixed(2)
    };

    // We use this method for update the quantity
    var handleUpdateQuantityOfCartItem = function handleUpdateQuantityOfCartItem(id, quantity) {
      dispatch({
        type: _ShoppingCartActions.UPDATE_SHOPPING_CART_ITEM,
        id: id,
        model: {
          quantity: quantity
        },
        onSuccess: function onSuccess() {
          return fetchShoppingCart(cartId);
        }
      });
    };
    // We use this method for delete an item from the shopping cart
    var handleDeleteCartItem = function handleDeleteCartItem(id) {
      dispatch({
        type: _ShoppingCartActions.DELETE_SHOPPING_CART_ITEM,
        id: id,
        onSuccess: function onSuccess() {
          fetchShoppingCart(cartId);
        }
      });
    };
    var handleUpdateCartItems = function handleUpdateCartItems(data) {
      dispatch({
        type: _ShoppingCartActions.UPDATE_SHOPPING_CART_ITEMS,
        items: data.items,
        onSuccess: function onSuccess() {
          fetchShoppingCart(cartId);
          if (data.onSuccess) data.onSuccess();
        }
      });
    };
    return {
      shoppingCartType: shoppingCartType,
      fetchCartInProgress: fetchCartInProgress,
      fetchCartItemsInProgress: fetchCartItemsInProgress,
      cart: cart,
      wallet: _lodash.default.has(shoppingCartType, 'welletId') ? user.wallets[0] : undefined,
      //_.find(user.wallets, { name: shoppingCartType.welletId }),
      cartItems: cartItems,
      primaryCartItems: primaryCartItems,
      primaryCartItemsGroupedBySeller: primaryCartItemsGroupedBySeller,
      subTotal: subTotal,
      subTotalOriginal: subTotalOriginal,
      itemsNumber: itemsNumber,
      buyerCommission: buyerCommission,
      calculateAmountToBePayed: calculateAmountToBePayed,
      onUpdateQuantityOfCartItem: handleUpdateQuantityOfCartItem,
      onDeleteCartItem: handleDeleteCartItem,
      onUpdateCartItems: handleUpdateCartItems
    };
  };
}